import React from 'react'
import { useStoreConfig } from 'config'
import { getCanonical, getFileExtension } from '../util'
import Head from 'next/head'
import { useTranslation } from 'react-i18next'
import { DefaultOGImage } from '@components/seo/src/ImagePath'

export type ReferralsProps = {
    pathname: string
}

export const Referrals = ({ pathname }: ReferralsProps): JSX.Element => {
    const config = useStoreConfig()
    const { seo, base } = config
    const { t } = useTranslation()

    const title = t('Refer and earn')
    const description = t(
        'Give your friends $10 off their first order of $70 and get $10 (in points) for each successful referral'
    )

    const ogImageAlt =
        seo?.default?.openGraph?.images &&
        seo?.default?.openGraph?.images[0]?.alt

    const ogImageContent = `${base.url.baseUrl}${DefaultOGImage}`

    return (
        <Head>
            <title>{title}</title>
            <meta name="title" content={title} />
            <meta name="description" content={String(description)} />
            <link
                rel="canonical"
                href={getCanonical(pathname, base.url.baseUrl)}
            />
            {/* TWITTER */}
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta
                property="twitter:domain"
                content={seo.default.twitter?.handle}
            />
            <meta
                property="twitter:url"
                content={getCanonical(pathname, base.url.baseUrl)}
            />
            <meta name="twitter:card" content={seo.default.twitter?.cardType} />
            <meta name="twitter:image" content={ogImageContent} />
            {/* OPEN GRAPH */}
            <meta
                property="og:url"
                content={getCanonical(pathname, base.url.baseUrl)}
            />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={ogImageContent} />
            <meta property="og:image:alt" content={ogImageAlt} />
            <meta
                property="og:image:type"
                content={`image/${getFileExtension(ogImageContent!)}`}
            />
            <meta name="robots" content="index, follow" />

            <meta property="og:site_name" content={seo.default.twitter?.site} />
        </Head>
    )
}
